export const apiList = {
    inquire: "/api/inquire", // 방 사용 토큰 발급
}